import {CHARTKIT_WIDGET_TYPE} from '../ChartKit/components/Widget/Widget';
import {Markdown} from '../ChartKit/components/Widget/components/Markdown/Markdown';

export default {
    key: CHARTKIT_WIDGET_TYPE.MARKDOWN,
    value: Markdown,
};
